<template>
  <div>
    <!-- 监控页面 -->
    <div class="right right-overflow" :style="'height:'+screenHeight"> 
      <div class="slip_in_animation">
        <div class="right-content slip_in_animation">
          <div class="type-title">
            <div style="font-size: 22px;">厂区监控</div>
          </div>
          <div class="item-info">
            <video
              style="width: 100%; height: auto"
              controls
              src="https://player.alicdn.com/video/editor.mp4"
            ></video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {
      selectIndex: 1,
      nowTime: "",
    };
  },
  methods: {},
};
</script>
  <style scoped lang="scss">
::-webkit-scrollbar {
  width: 0px;
}

.main .right {
  width: 21.3vw;
  height: 75vh;
  background: rgba(17,47,107, 0.6);
  overflow: hidden;
}

.main .right {
  float: right;
  margin-right: 20px;
  .right-content {
    box-sizing: border-box;
    padding: 20px;
    color: #fff;
    .item-info {
      > div {
        margin: 20px 0;
        font-size: 20px;
      }
    }
  }
}
.right-overflow {
  overflow-y: scroll !important;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}

::v-deep .main .right .right-content .type-title {
  font-size: 22px!important;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
  